module.exports = __webpack_public_path__ + "static/media/quick_filter.4e0ff0c7.svg";